import { render, staticRenderFns } from "./intraocularTension.vue?vue&type=template&id=6176ed20&scoped=true&"
import script from "./intraocularTension.vue?vue&type=script&lang=js&"
export * from "./intraocularTension.vue?vue&type=script&lang=js&"
import style0 from "./intraocularTension.vue?vue&type=style&index=0&id=6176ed20&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6176ed20",
  null
  
)

export default component.exports